export default __webpack_public_path__ + "static/media/googlecolor.08e9c206.svg";